module.exports = __webpack_public_path__ + "img/report.ddaa0230.svg";